// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_36-1";
export var movingGradient = "_36-4";
export var movingGradientBlock = "_36-2";
export var skeleton = "_36-0";
export var skeletonText = "_36-3";